import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'expired.password.title',
    defaultMessage: 'Reset your password',
  },
  headTitle: {
    id: 'expired.password.head.title',
    defaultMessage: 'Security request from your admin',
  },
  contentText: {
    id: 'expired.password.email.content',
    defaultMessage:
      'Your admin wants you to set a new password before you log back in. We will send the password reset link to your email address:',
  },
  sendResetEmailButton: {
    id: 'expired.password.button.send',
    defaultMessage: 'Send password reset email',
  },
  emailSentFlagFailedTitle: {
    id: 'expired.password.email.flag.error.title',
    defaultMessage: 'Unable to send email',
  },
  emailSentFlagFailedDesc: {
    id: 'expired.password.email.flag.general.error.desc',
    defaultMessage:
      'Something went wrong when we tried to send the password reset link. Try again.',
  },
  emailSentFlagTooManyEmailsDesc: {
    id: 'expired.password.email.flag.toomanyemails.error.desc',
    defaultMessage: "We've sent too many emails, please try again later.",
  },
  emailSentFlagSuccessTitle: {
    id: 'expired.password.email.flag.success.title',
    defaultMessage: 'Email successfully sent',
  },
  emailSentFlagSuccessDesc: {
    id: 'expired.password.email.flag.success.desc',
    defaultMessage: 'Check your email for the password reset link.',
  },
});
